import(/* webpackMode: "eager" */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\app\\layout.tsx");
